export { default as HarmWatch } from './HarmWatch';


// WEBPACK FOOTER //
// ./src/features/harmwatch/index.js